export default __webpack_public_path__ + "static/media/overlay.665665bb.png";